// @flow strict

import React from 'react';
import { Button } from '@ansarada/ace-react';
import OnBoardingLayout from '../OnBoardingLayout';

type PropsType = {|
  title: string,
  onNext: () => void,
  description: string,
  bgMobile: string,
  bgDesktop: string,
|};
const Welcome = ({ title, onNext, description, bgDesktop, bgMobile }: PropsType) => (
  <OnBoardingLayout
    title={title}
    actionButtons={[
      <Button onClick={onNext} key="next" variant="Primary" id="s3-next">
        Next
      </Button>,
    ]}
    bgDesktop={bgDesktop}
    bgMobile={bgMobile}
  >
    <p>{description}</p>
  </OnBoardingLayout>
);

export default Welcome;
